<template>
	<router-view />
</template>

<script>
export default {
	name: "App",
	data: () => ({
		//
	}),
	beforeCreate() {
		if (this.$store.getters["user/isLoggedIn"]) {
			this.$store.dispatch("user/verifyLogin").catch(() => {

			})
		}
	},
}
</script>
<style>
.v-application {
	font-family: Sarabun !important;
}
h1 {
	font-weight: bold;
	/*color: var(--v-secondary-base) /*#3d2645*/;
	text-align: center;
}
.contentRow {
	margin-top: 20px;
	padding: 20px;
	width: 100%;
	margin-bottom: 30px;
	background-color: #fff /*#e3e3e3*/;
	border: 1px solid transparent;
	border-radius: 4px;
	margin-left: 0px !important;
	margin-right: 0px;
	position: relative;
}
</style>